import { useState } from 'react';
import { Button, Col, List, ListItem, Row, Typography } from 'darrius';

import { MdKeyboardArrowDown, MdKeyboardControlKey } from 'react-icons/md';

import { type ISubCategoriesProps } from '../../../modules/profile/shared/pageProps/getSubCategoriesProps/@interfaces';
import styles from './ProfileExpertises.module.scss';
import clsx from 'clsx';

interface IProfileExpertises {
  expertises: ISubCategoriesProps;
}

export const ProfileExpertises = ({ expertises }: IProfileExpertises) => {
  if (!expertises) return null;

  const [showMore, setShowMore] = useState(true);

  const BUTTON_SEE_MORE_TEXT = 'Ver mais';
  const BUTTON_SEE_LESS_TEXT = 'Ver menos';

  const handleClick = () => {
    setShowMore((prevState) => !prevState);
  };

  const IconButton =
    showMore === true ? MdKeyboardArrowDown : MdKeyboardControlKey;

  return (
    <section className={`${styles.section}`} id={expertises.id}>
      <Row>
        <Col className="col-sm-12">
          <Typography.Subtitle size="l" className={styles.subtitle}>
            {expertises.title}
          </Typography.Subtitle>
          <List className={`expertises__list ${styles['list--with-bullet']}`}>
            {expertises.items.map((item, index) => {
              const clsxHideListItemContent = clsx('expertises__list-item', {
                hide: showMore && index > 2,
              });

              return (
                <ListItem key={item} className={clsxHideListItemContent}>
                  <Typography.Text className={styles.text}>
                    {item}
                  </Typography.Text>
                </ListItem>
              );
            })}
          </List>
          <Button.Root
            variation="clear"
            className={`see-more-button ${styles['see-more-button']}`}
            onClick={handleClick}
            size="small"
          >
            <IconButton className={styles['see-more-button-icon']} size={25} />
            {showMore ? BUTTON_SEE_MORE_TEXT : BUTTON_SEE_LESS_TEXT}
          </Button.Root>
        </Col>
      </Row>
    </section>
  );
};
